export enum TopicType {
  USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST',
  USER_LOGIN_RESPONSE = 'USER_LOGIN_RESPONSE',
  ALERT_NOTIFICATION_REQUEST = 'ALERT_NOTIFICATION_REQUEST',
  CLOSE_ALERT_REQUEST = 'CLOSE_ALERT_REQUEST',
  CODE_DATA_REQUEST = 'CODE_DATA_REQUEST',
  GET_USER_REQUEST = 'GET_USER_REQUEST',
  TASK_ASSIGNMENT_RESPONSE = 'TASK_ASSIGNMENT_RESPONSE',
  CODE_UPDATE_REQUEST = 'CODE_UPDATE_REQUEST',
  ROLE_DATA_REQUEST = 'ROLE_DATA_REQUEST',
  ROLE_REASSIGNMENT_REQUEST = 'ROLE_REASSIGNMENT_REQUEST',
  LOCATION_DATA_REQUEST = 'LOCATION_DATA_REQUEST',
  MANAGE_ASSIGNMENT_REQUEST = 'MANAGE_ASSIGNMENT_REQUEST',
  UPDATE_REPORT_RESPONSE = 'UPDATE_REPORT_RESPONSE',
  DATA_REQUEST = 'DATA_REQUEST',
  DATA_RESPONSE = 'DATA_RESPONSE',
  PERMISSION_UPDATE_REQUEST = 'PERMISSION_UPDATE_REQUEST',
  GLOBALCONFIG_UPDATE_REQUEST = 'GLOBALCONFIG_UPDATE_REQUEST',
  TASK_NOTIFICATION_REQUEST = 'TASK_NOTIFICATION_REQUEST',
  USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST',
  GET_USERS_RESPONSE = 'GET_USERS_RESPONSE',
  ALERT_NOTIFICATION = 'ALERT_NOTIFICATION',
  ALERT_STATUS_UPDATE = 'ALERT_STATUS_UPDATE',
  ALARM_NOTIFICATION = 'ALARM_NOTIFICATION',
  ALARM_STATUS_UPDATE = 'ALARM_STATUS_UPDATE',
  TASK_NOTIFICATION = 'TASK_NOTIFICATION',
  TASK_ASSIGNMENT_REQUEST = 'TASK_ASSIGNMENT_REQUEST',
  TASK_STATUS_UPDATE = 'TASK_STATUS_UPDATE',
  CODE_DATA_RESPONSE = 'CODE_DATA_RESPONSE',
  GLOBALCONFIG_UPDATE_RESPONSE = 'GLOBALCONFIG_UPDATE_RESPONSE',
  ROLE_DATA_RESPONSE = 'ROLE_DATA_RESPONSE',
  LOCATION_DATA_RESPONSE = 'LOCATION_DATA_RESPONSE',
  USER_UPDATE_RESPONSE = 'USER_UPDATE_RESPONSE',
  CLOSE_TASK_REQUEST = 'CLOSE_TASK_REQUEST',
  ASSIGNMENT_DATA_RESPONSE = 'ASSIGNMENT_DATA_RESPONSE',
  SHIFT_DATA_RESPONSE = 'SHIFT_DATA_RESPONSE',
  PATIENT_DATA_RESPONSE = 'PATIENT_DATA_RESPONSE',
  STAFF_DATA_RESPONSE = 'STAFF_DATA_RESPONSE',
  GENERATE_REPORT_RESPONSE = 'GENERATE_REPORT_RESPONSE',
  ALERT_DATA_RESPONSE = 'ALERT_DATA_RESPONSE',
  TASK_DATA_RESPONSE = 'TASK_DATA_RESPONSE',
  CONFIG_DATA_RESPONSE = 'CONFIG_DATA_RESPONSE',
  SECURITY_ASSIGNMENT_DATA_RESPONSE = 'SECURITY_ASSIGNMENT_DATA_RESPONSE',
  ASSISTREQ_NOTIFICATION = 'ASSISTREQ_NOTIFICATION',
  ASSISTREQ_STATUS_UPDATE = 'ASSISTREQ_STATUS_UPDATE',
  CLOSE_ASSISTREQ_REQUEST = 'CLOSE_ASSISTREQ_REQUEST',
  ASSISTREQ_DATA_RESPONSE = 'ASSISTREQ_DATA_RESPONSE',
  DEPARTMENT_DATA_RESPONSE = 'DEPARTMENT_DATA_RESPONSE',
  USER_CREATE_REQUEST = 'USER_CREATE_REQUEST',
  USER_DELETE_REQUEST = 'USER_DELETE_REQUEST',
  USER_CREATE_RESPONSE = 'USER_CREATE_RESPONSE',
  PING = 'backend-heartbeat',
  WEB_PING = 'web-ping',
  DELETE_REPORT_RESPONSE = 'DELETE_REPORT_RESPONSE',
  MOBILE_HEART_BEAT = 'mobile-heartbeat',
  NURSE_CALL_NOTIFICATION = 'NURSE_CALL_NOTIFICATION',
  NURSE_CALL_STATUS_UPDATE = 'NURSE_CALL_STATUS_UPDATE',
  NURSE_CALL_DATA_RESPONSE = 'NURSE_CALL_DATA_RESPONSE',
  FIN_PING_REQUEST = 'FIN_PING_REQUEST',
  MANAGE_REPORTS_REQUEST = 'MANAGE_REPORTS_REQUEST',
  READ_REPORT_RESPONSE = 'READ_REPORT_RESPONSE',
  CREATE_REPORT_RESPONSE = 'CREATE_REPORT_RESPONSE',
  ALARM_DATA_RESPONSE = 'ALARM_DATA_RESPONSE',
}
